export enum PullingTimeout {
    Default = 3_000,
    VRemover = 5_000,
}
